import React from 'react';

interface BulkActionBarProps {
  count: number;
  onDelete: () => void;
  onClear: () => void;
}

const BulkActionBar: React.FC<BulkActionBarProps> = ({ count, onDelete, onClear }) => (
  <div className="flex items-center gap-4 px-4 py-2 rounded-lg ring-1 ring-gray-200 dark:ring-gray-800 bg-blue-50/60 dark:bg-blue-900/20">
    <span className="text-sm font-medium text-gray-700 dark:text-gray-200">{count} selected</span>
    <button type="button" onClick={onDelete} className="text-sm font-medium text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300">Delete selected</button>
    <button type="button" onClick={onClear} className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200">Clear</button>
  </div>
);

export default BulkActionBar;
